import downloadCenter from './downloadCenter'
export default downloadCenter
